export default __webpack_public_path__ + "static/slide5-tablet-e5e3c42ab4869960510acc0e1ab2f31e.png";